import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation, useLazyQuery } from '@apollo/client'
import { VERIFY_USER_EMAIL_QUERY, GET_USERDATA_QUERY } from '../services/GraphQLQueries'
import { setAuthToken, storeUserSession } from '../services/auth'
import SideMenu from '../layouts/SideMenu'
import '../layouts/stylesheets/loader-style.css'

export default function VerifyMainUserEmail() {
    const [verifyUserEmail, { loading }] = useMutation(VERIFY_USER_EMAIL_QUERY)
    const key = new URLSearchParams(window.location.search).get('resetkey')
    const [verifyError, setVerifyError] = useState('')
    const navigate = useNavigate()
    const [userDataQuery] = useLazyQuery(GET_USERDATA_QUERY)

    useEffect(() => {
        if (!key) {
            setVerifyError('This verification link is missing a reset key. Please use the full link from your email.')
            return
        }

        verifyUserEmail({
            variables: { resetToken: key },
        }).then(res => {
            console.log("response:", res);
            if(res.data.verifyUserEmail.bearerToken) {
                setAuthToken(res.data.verifyUserEmail.bearerToken);
                userDataQuery().then(userDataRes => {
                    console.log("userDataRes:", userDataRes);
                    storeUserSession({
                        userData: userDataRes.data?.userdata || null,
                        organizationData: userDataRes.data?.organization || null,
                    });

                    navigate("/trackers");
                });
            } else {
                setVerifyError(res.data?.verifyUserEmail?.error || 'Unable to verify your email.')
            }
        }).catch(() => {
            setVerifyError('Unable to verify your email.')
        });
    }, [key, navigate, userDataQuery, verifyUserEmail]);

    return (
        <div className="flex justify-center items-center" aria-live="polite">
            <SideMenu></SideMenu>
            <div className="w-full flex justify-center">
                {verifyError ? (
                    <div className="grid gap-4 md:w-96 w-72 text-center">
                        <h1 className="text-2xl font-semibold text-gray-900">Verification failed</h1>
                        <p className="text-sm text-gray-600">{verifyError}</p>
                    </div>
                ) : loading ? <>
                    <div className="loader-wrapper">
                        <div className='flex justify-center items-center'>
                            <div className='grid gap-10'>
                                <div className="loader"></div>
                                <div className='text-center'>Verifying...</div>
                            </div>
                        </div>
                    </div>
                </> : (
                    <div className="loader-wrapper">
                        <div className='flex justify-center items-center'>
                            <div className='grid gap-10'>
                                <div className="loader"></div>
                                <div className='text-center'>Logging in...</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
